var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.804,
    height: 19.804,
    viewBox: "0 0 19.804 19.804",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-feed-4485656",
    transform: "translate(-105 -35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4341",
    "data-name": "Path 4341",
    d: "M121.84,123.615v.842a.709.709,0,0,1-.707.707H105.707a.709.709,0,0,1-.707-.707V109.031a.709.709,0,0,1,.707-.707h.842v14.584a.709.709,0,0,0,.707.707Z",
    transform: "translate(0 -70.361)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4342",
    "data-name": "Path 4342",
    d: "M194.453,35H179.027a.709.709,0,0,0-.707.707V51.133a.709.709,0,0,0,.707.707h15.426a.709.709,0,0,0,.707-.707V35.707A.709.709,0,0,0,194.453,35ZM190.6,47.978h-7.709a.707.707,0,0,1,0-1.415H190.6a.707.707,0,1,1,0,1.415Zm0-3.855h-7.709a.707.707,0,0,1,0-1.415H190.6a.707.707,0,1,1,0,1.415Zm0-3.855h-7.709a.707.707,0,0,1,0-1.415H190.6a.707.707,0,1,1,0,1.415Z",
    transform: "translate(-70.357)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedIcon);
export default __webpack_public_path__ + "static/media/feed-icon.89f23797b2aef1625c3bec57f22e67d9.svg";
export { ForwardRef as ReactComponent };